import { useEffect, useState } from "react";
import SuperAdminLayout from "./SuperAdminLayout";

export default function SuperAdminPlaceholder({ title, description }) {
    return (
        <SuperAdminLayout>
            <div style={styles.page} className="page-fade-in">
                <div style={styles.header}>
                    <div style={styles.statusPill}>
                        <div style={styles.pulseDot} />
                        MÓDULO EN DESARROLLO
                    </div>
                    <h1 style={styles.title}>{title}</h1>
                    <p style={styles.subtitle}>{description}</p>
                </div>

                <div style={styles.card} className="glass-effect">
                    <div style={styles.emptyState}>
                        <div style={styles.iconWrapper}>
                            <div style={styles.icon}>🛠️</div>
                            <div style={styles.iconRing} />
                        </div>
                        <h2 style={styles.emptyTitle}>Experiencia Premium en Proceso</h2>
                        <p style={styles.emptyText}>
                            Estamos diseñando una interfaz de alto rendimiento para la gestión de <strong>{title.toLowerCase()}</strong>.
                            Este módulo estará disponible en la próxima actualización del núcleo Conexo OS.
                        </p>

                        <div style={styles.statsPreview}>
                            <div style={styles.statLine}>
                                <div style={styles.dot} />
                                <span style={styles.statText}>Integración con API global</span>
                            </div>
                            <div style={styles.statLine}>
                                <div style={{ ...styles.dot, background: 'var(--secondary)' }} />
                                <span style={styles.statText}>Visualización de datos en tiempo real</span>
                            </div>
                            <div style={styles.statLine}>
                                <div style={{ ...styles.dot, background: 'var(--accent)' }} />
                                <span style={styles.statText}>Exportación avanzada de reportes</span>
                            </div>
                        </div>

                        <button style={styles.notifiedBtn} disabled>
                            Notificarme al lanzamiento
                        </button>
                    </div>
                </div>
            </div>
        </SuperAdminLayout>
    );
}

const styles = {
    page: { maxWidth: "1200px" },
    header: { marginBottom: "3.5rem" },
    statusPill: { background: 'rgba(59, 130, 246, 0.1)', border: '1px solid rgba(59, 130, 246, 0.2)', color: 'var(--primary)', fontSize: '0.65rem', fontWeight: '900', padding: '0.4rem 0.8rem', borderRadius: '99px', display: 'flex', alignItems: 'center', gap: '6px', letterSpacing: '0.05em', width: 'fit-content', marginBottom: '1rem' },
    pulseDot: { width: '6px', height: '6px', borderRadius: '50%', background: 'var(--primary)', boxShadow: '0 0 8px var(--primary)' },
    title: { fontSize: "2.5rem", fontWeight: "800", color: "#fff", margin: "0 0 0.5rem 0", letterSpacing: "-0.03em" },
    subtitle: { color: "var(--text-soft)", margin: 0, fontSize: "1.1rem" },
    card: {
        borderRadius: "2rem",
        padding: "6rem 2rem",
        display: "flex",
        justifyContent: "center",
        position: 'relative',
        overflow: 'hidden'
    },
    emptyState: { textAlign: "center", maxWidth: "500px", display: 'flex', flexDirection: 'column', alignItems: 'center' },
    iconWrapper: { position: 'relative', marginBottom: '2.5rem' },
    icon: { fontSize: "4.5rem", position: 'relative', zIndex: 1 },
    iconRing: { position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '120px', height: '120px', border: '2px dashed var(--primary)', borderRadius: '50%', opacity: 0.2, animation: 'spin 20s linear infinite' },
    emptyTitle: { color: "#fff", fontSize: "1.75rem", fontWeight: "800", marginBottom: "1.5rem", letterSpacing: '-0.02em' },
    emptyText: { color: "var(--text-soft)", lineHeight: "1.7", fontSize: '1rem', marginBottom: '2.5rem' },
    statsPreview: { display: 'flex', flexDirection: 'column', gap: '1rem', width: '100%', padding: '2rem', background: 'rgba(255,255,255,0.02)', borderRadius: '1.5rem', border: '1px solid var(--border-soft)', marginBottom: '2.5rem' },
    statLine: { display: 'flex', alignItems: 'center', gap: '12px', textAlign: 'left' },
    dot: { width: '8px', height: '8px', borderRadius: '50%', background: 'var(--primary)' },
    statText: { color: 'var(--text-main)', fontSize: '0.9rem', fontWeight: '600' },
    notifiedBtn: { padding: '1rem 2rem', borderRadius: '12px', background: 'rgba(255,255,255,0.05)', border: '1px solid var(--border-soft)', color: 'var(--text-soft)', fontWeight: '700', fontSize: '0.9rem', cursor: 'not-allowed' }
};
